{
    "SSO_Login_Title": "Início de sessão único (SSO)",
    "SSO_Login_Description": "Aguarde, a validar os detalhes do utilizador. Isto não deve demorar muito.",
    "SSO_Login_Error": "Lamentamos, mas não conseguimos localizá-lo. Por favor, tente novamente. Se o problema persistir, contacte o administrador da aplicação.",
    "SSO_MissingCode_Error": "Desculpe, algo correu mal. Tente novamente. Se o problema persistir, contacte o administrador da aplicação.",
    "NAME": "SSOLanguage"
}